import { useState } from 'react';
import { ImageOff } from 'lucide-react';
import { thumbnailUrl } from '../../lib/treatmentReferences';
import { cn } from '../../lib/utils';

/**
 * One linked frame. Tries the small thumbnail, then the address as linked,
 * then gives up and says so. With `openHref`, the give-up card links there;
 * the editor has its own open button on top, so it leaves this out.
 * `imgClassName` adds to the image (the shared page's hover scale).
 */
export default function ReferenceFrame({ url, alt, openHref, imgClassName }) {
  const sources = [...new Set([thumbnailUrl(url), url])];
  const [attempt, setAttempt] = useState(0);

  if (attempt >= sources.length) {
    return (
      <div className="w-full h-full flex flex-col items-center justify-center gap-1 text-xs text-muted-foreground bg-mist p-2 text-center">
        <ImageOff className="w-4 h-4" aria-hidden="true" />
        Can't load this frame
        {openHref && (
          <a href={openHref} target="_blank" rel="noopener noreferrer" className="text-clay underline">
            Open it
          </a>
        )}
      </div>
    );
  }
  return (
    <img
      src={sources[attempt]}
      alt={alt}
      referrerPolicy="no-referrer"
      loading="lazy"
      className={cn('w-full h-full object-cover', imgClassName)}
      onError={() => setAttempt((a) => a + 1)}
    />
  );
}
